import { v1 } from './v1';

export const telemetry = {
  v1,
};
